import { render, staticRenderFns } from "./CaptureTypeList.vue?vue&type=template&id=0bcb5ef4&"
import script from "./CaptureTypeList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CaptureTypeList.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcb5ef4')) {
      api.createRecord('0bcb5ef4', component.options)
    } else {
      api.reload('0bcb5ef4', component.options)
    }
    module.hot.accept("./CaptureTypeList.vue?vue&type=template&id=0bcb5ef4&", function () {
      api.rerender('0bcb5ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreFilePicker/components/CaptureTypeList.vue"
export default component.exports